<template>
  <button-toggle
    class="button-watch"
    icon-href="#flag"
    :active="active"
    :size="size"
    title-active="Снять с контроля"
    title-inactive="Поставить на контроль"
    @click="onClick"
  />
</template>

<script>
import ButtonToggle from '@@/shared/form/ButtonToggle';

export default {
  components: {
    ButtonToggle
  },

  props: {
    active: {
      type: Boolean,
      required: true
    },
    size: {
      type: Number,
      default: 20
    }
  },

  methods: {
    onClick(active) {
      if (!active || confirm('Подтвердите удаление документа из контроля.')) {
        this.$emit('click', active);
      }
    }
  }
};
</script>
